import altura from "@/assets/cursos/altura.jpg";
import subterranea from "@/assets/cursos/subterranea.jpg";
import electrica from "@/assets/cursos/electrica.jpg";
import emergencia from "@/assets/cursos/emergencia.jpg";
import conduccion from "@/assets/cursos/conduccion.jpg";
import elearning from "@/assets/cursos/elearning.jpg";
import izaje from "@/assets/cursos/izaje.jpg";
import general from "@/assets/cursos/general.jpg";
import ds44 from "@/assets/ds44-curso.webp.asset.json";

const RULES: Array<{ keys: string[]; src: string }> = [
  { keys: ["decreto 44", "ds 44", "normativa en prevencion"], src: ds44.url },
  { keys: ["e-learning", "elearning", "induccion"], src: elearning },
  { keys: ["altura", "alza hombres", "herramientas manuales"], src: altura },
  {
    keys: [
      "autorrescatador",
      "refugio",
      "gases",
      "confinado",
      "geomecanica",
      "talud",
      "cintas de confinamiento",
      "sustancias peligrosas",
    ],
    src: subterranea,
  },
  { keys: ["electric", "nfpa", "bloqueo", "energizada"], src: electrica },
  { keys: ["primeros auxilios", "extintor", "incendio", "emergencia", "epp"], src: emergencia },
  { keys: ["transito", "conduccion", "defensiva", "4x4", "vehiculo"], src: conduccion },
  { keys: ["izaje", "guardas", "protecciones", "pisos industriales"], src: izaje },
];

const normalize = (s: string) =>
  s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

/** Imagen de portada para un curso: usa la cargada en el admin o una temática por defecto. */
export function cursoImagen(title: string, imageUrl?: string | null): string {
  if (imageUrl) return imageUrl;
  const t = normalize(title);
  for (const rule of RULES) {
    if (rule.keys.some((k) => t.includes(k))) return rule.src;
  }
  return general;
}
